import { render, staticRenderFns } from "./QuickPayment.vue?vue&type=template&id=13f2f35c"
import script from "./QuickPayment.vue?vue&type=script&lang=js"
export * from "./QuickPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports